import { useMutation } from "@tanstack/react-query";
import ApiClient from "../../../api/ApiClient";
import { AxiosError } from "axios";

async function deleteOption({ categoryId, optionId }: { categoryId: number; optionId: number }): Promise<void> {
    try {
       await ApiClient({ url: `categories/${categoryId}/options/${optionId}`, method: "DELETE" });
    } catch (error) {
        throw new Error(error instanceof AxiosError ? error.response?.data?.error : "An unexpected error occurred");
    }
}

export function useDeleteOptionMutation(onSuccess?: () => void, onError?: (error: Error) => void) {
    return useMutation<void, Error, { categoryId: number; optionId: number }>({
        mutationKey: ["delete-option"],
        mutationFn: deleteOption,
        onSuccess,
        onError,
    });
}